<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_x"></a><a id="page_xi"><b>THE <span class="half1">LITTLE</span> <span class="half1a">BIG</span> <span class="half2">NUMBER</span></b></a></p><a id="page_xi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_half1.vue?72dc8143